export default function InterviewTab({
  isActive,
  isTabsDisabled,
  onSelect,
  children
}) {
  return (
    <div className="nav-item">
      <a
        className={`nav-link ${isActive ? "active" : ""} ${
          isTabsDisabled ? "disabled" : ""
        }`}
        data-toggle="tab"
        href="#!"
        role="tab"
        aria-controls="educationWork"
        aria-selected={isActive}
        onClick={onSelect}
      >
        {children}
      </a>
    </div>
  );
}
